import { addAsset } from '../lib/xes/xes-lib'
class Storage {
  constructor () {
    this.assetHost = 'https://rescode.xesimg.com/hufu-code/common/mit'
  }
  addXesWebStore (mblock) {
    mblock.addWebStore(
      asset => `https://rescode.xesimg.com/hufu-code/common/mit-error-assets/error.${asset.dataFormat}`
    )
    mblock.addWebStore(
      asset => `https://rescode.xesimg.com/hufu-code/common/mit-error-assets/error.${asset.dataFormat}`
    )
    mblock.addWebStore(
      this.getAssetGetConfig.bind(this),
      this.getAssetCreateConfig.bind(this),
      this.getAssetCreateConfig.bind(this)
    )
  }
  getAssetGetConfig (asset) {
      addAsset(asset.assetId)
      return `${this.assetHost}/${asset.assetId}.${asset.dataFormat}`;
  }
  getAssetCreateConfig (asset) {
      return {
          // There is no such thing as updating assets, but storage assumes it
          // should update if there is an assetId, and the asset store uses the
          // assetId as part of the create URI. So, force the method to POST.
          // Then when storage finds this config to use for the "update", still POSTs
          method: 'post',
          url: `${this.assetHost}/${asset.assetId}.${asset.dataFormat}`,
          withCredentials: true
      };
  }
}

export default new Storage()